<template>
  <el-select
      v-if="computedIsEdit"
      v-model="returnValue"
      :disabled="disabled"
      :clearable="clearable"
      :filterable="filterable"
      :placeholder="$t(placeholder)"
      :multiple="multiple"
      :title="$t(placeholder)"
      :style="getStyle"
      :size="computedSize"
      @change="emitChange"
      @clear="$emit('clear')"
  >
    <el-option v-if="!notNull" :key="'empty'" :value="null" :label="$t('请选择')"/>
    <template v-for="(o,i) in dictListInner"><!-- 对象list形式的数据 -->
      <el-option
          :key="o[listCode]+'_'+i"
          :value="o[listCode]"
          :label="$t(o[listLabelInner] || o['label'])"
          :disabled="o.disabled"
          @click.native="$emit('select',o)"
      />
      <el-option
          v-for="o1 in o.children"
          :key="o1[listCode]+'_'+i"
          :value="o1[listCode]"
          :label="'|--' + $t(o1[listLabelInner] || o1['label'])"
          :disabled="o1.disabled"
      />
    </template>
    <slot/>
  </el-select>
  <span v-else>
    <template v-if="Array.isArray(returnValue)">
      <div v-for="(val, index) in returnValue" :key="index" class="subValue">{{ $t(getValue(val)) }} </div>
    </template>
    <template v-else-if="colorMapInner && Object.keys(colorMapInner).length">
      <el-tag effect="dark" :color="colorMapInner[returnValue]">{{ $t(getValue(returnValue)) }}</el-tag></template>
    <template v-else>{{ $t(getValue(returnValue)) }}</template>
  </span>
</template>
<script>
import mixin_div from '@/mixin/mixin_div'

import {getProFromParent} from '@/utils/otherUtil'

const baseColorMap = {
  1: 'blue', // 蓝色
  2: 'green', // 绿色
  3: 'red', // 红色
  4: 'yellow', // 黄色
  5: 'orange', // 橙色
  6: 'purple', // 紫色
  7: 'gray', // 灰色
  8: 'black', // 黑色
  9: 'Pink', // 粉红色
  10: 'Brown', // 棕色
  11: 'Cyan', // 青色
  12: 'Magenta', // 洋红色
  13: 'Lime', // 酸橙色
  14: 'Silver', // 银色
  15: 'Gold', // 金色
  16: 'Teal', // 青绿色
  17: 'Navy', // 海军蓝
  18: 'Maroon', // 栗色
  19: 'Olive' // 橄榄绿
}
/**
 * 快捷的el-select选择框
 */
export default {
  name: 'Zselect',
  mixins: [mixin_div],
  props: {
    /**
     * 字典类名simpleClassName    v-model不能传boolean
     */
    classname: {type: String},
    entityName: {type: String},
    placeholder: {type: String},
    multiple: {type: Boolean, default: false},
    filterable: {type: Boolean, default: true},
    clearable: {type: Boolean, default: true},
    isUseCodeAsName: {type: Boolean, default: false},
    notNull: {type: Boolean, default: true},
    defaultFirst: {type: Boolean, default: false},
    parentStack: {type: Number, default: 5}, // 获取父节点属性，只向上找5层（不然太影响性能）
    param: {}, // 额外参数,用于触发事件时的额外信息 例如表格中的 scope.row
    // dictMap: {},
    dictList: {},
    listCode: {default: 'code'},
    listLabel: {},
    filterPre: {type: String, default: ''},
    filterFun: {type: Function, default: () => true},
    excludePre: {type: String, default: ''},
    colorMap: {}
  },
  data() {
    return {
      dictListInner: [],
      returnValue: this.value,
      // map: this.dictMap,
      oldKey: null,
      listLabelInner: null,
      colorMapInner: null
    }
  },
  computed: {
    getClearable() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.returnValue = null
      const proFromParent = getProFromParent(this, 'clearable', false, this.parentStack)
      return proFromParent
    }
  },
  watch: {
    // dictList(newVal) {
    //   this.dictListInner = newVal
    // },
    value(newVal) {
      if (this.returnValue !== newVal) {
        this.returnValue = newVal
      }
    },
    returnValue(newVal) {
      this.$emit('input', newVal)
    }
  },
  mounted() {
    this.returnValue = this.value
  },
  async created() {
    console.log('Zselect init')
    this.colorMapInner = this.colorMap ? {...this.colorMap} : null
    this.listLabelInner = this.listLabel
    this.oldKey = this.value
    if (!this.dictListInner.length) {
      this.dictListInner = this.dictList || []
    }
    if (!this.dictListInner.length && this.entityName) {
      this.dictListInner = (await this.$store.dispatch('common/dictListComputeIfAbsent', this.entityName)) || []
    }
    if (!this.dictListInner.length && this.classname) {
      this.listLabelInner = this.listLabelInner || 'label'
      this.dictListInner = (await this.$store.dispatch('common/dictListComputeIfAbsentEnum', this.classname)) || []
    }
    this.dictListInner = this.dictListInner.filter(d => this.filterFun(d))
    if (this.isEmpty(this.returnValue) && this.dictListInner.length && (this.defaultFirst||this.dictListInner.length===1)) {
      this.returnValue = this.dictListInner[0][this.listCode]
    }
    if (!this.colorMapInner) {
      const colorMap = {}
      for (let i = 0; i < this.dictListInner.length; i++) {
        this.dictListInner.forEach(d => {
          colorMap[d[this.listCode]] = d.color || baseColorMap[i + 1] || 'blue'
        })
      }
      this.colorMapInner = colorMap
    }
    this.listLabelInner = this.listLabelInner || 'name'
  },
  methods: {
    emitChange(val) {
      // val = val || null
      // this.dispatch('ElFormItem', 'el.form.change', val)
      this.$emit('input', val)
      // (newKey,newValue,oldKey,oldValue,param)
      this.$emit('change', val, this.getValue(val), this.oldKey, this.getValue(this.oldKey), this.param)
      this.oldKey = this.value
    },
    getValue(key) {
      if (this.map) {
        return this.map[key]
      }
      if (this.dictListInner.length) {
        for (const o of this.dictListInner) {
          if (o[this.listCode] === key) {
            return o[this.listLabelInner]
          }
        }
      }
      return null
    }
  }
}
</script>
<style scoped>
</style>

